export default "__VITE_ASSET__DQbnXwrM__"